
import {getTooltip} from './pulse-defs'
import PulseTooltip from './pulse-tooltip.vue'

export default {
  components: {
    PulseTooltip
  },
  props: {
    title: {type: String, required: true},
    line: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    tooltip: {type: String, default: undefined}
  },
  computed: {
    tt_data() {
      if (!this.tooltip) return
      return getTooltip(this.tooltip)
    },
    tt_title(){
      return this.tt_data?.title
    },
    tt_content(){
      return this.tt_data?.content
    }
  }
}
